import  gql  from 'graphql-tag'

export const PASSWORD_RESET = gql`mutation passwordReset($input: PasswordResetMutationInput!){
    passwordReset(input: $input){
        errors{
            field
            messages
        }
    }
}`;